// extracted by mini-css-extract-plugin
export default {"debtTracker":"DebtTracker_debtTracker__5x41x","mainTabs":"DebtTracker_mainTabs__rqsLH","tabContent":"DebtTracker_tabContent__yvcv6"};